import { Badge } from '@/components/ui/badge';
import { Button } from '../buttons/button';
import { useSelectedItems } from "@/context/SelectedItemsContext";
import { useState } from 'react';

//display one consultant
// eslint-disable-next-line react/prop-types
export default function ConsultantItem({ consultantName, onClick, isSelected, idConsultant }) {
  const { selectedItems } = useSelectedItems();

  // Calcul du nombre d'éléments sélectionnés pour ce consultant
  const selectedCount = selectedItems.filter(item => item.idConsultant === idConsultant).length;

  return (
    <Button
      showLeftIcon={false}
      leftIcon=""
      showRightIcon={false}
      rightIcon=""
      showText={true}
      onClick={onClick}
      sizePadding="firstDegree"
      style={`${isSelected ? "secondaryDressed" : "ghost"}`}
      className={`cursor-pointer w-full justify-start font-medium relative`}
    >
      {consultantName} {selectedCount > 0 && <Badge text={selectedCount} variant={"information"} className={"absolute top-0 right-1"}/>}
    </Button>
  );
}
